var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContentCopy({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 21,
    viewBox: "0 0 17 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 16.5C5.45 16.5 4.97917 16.3042 4.5875 15.9125C4.19583 15.5208 4 15.05 4 14.5V2.5C4 1.95 4.19583 1.47917 4.5875 1.0875C4.97917 0.695833 5.45 0.5 6 0.5H15C15.55 0.5 16.0208 0.695833 16.4125 1.0875C16.8042 1.47917 17 1.95 17 2.5V14.5C17 15.05 16.8042 15.5208 16.4125 15.9125C16.0208 16.3042 15.55 16.5 15 16.5H6ZM6 14.5H15V2.5H6V14.5ZM2 20.5C1.45 20.5 0.979167 20.3042 0.5875 19.9125C0.195833 19.5208 0 19.05 0 18.5V4.5H2V18.5H13V20.5H2Z",
    fill: "#444746"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentCopy);
export default __webpack_public_path__ + "static/media/content_copy.f17b103ccfc387fb71a62ad288df389b.svg";
export { ForwardRef as ReactComponent };